import { render } from "./ErpDraft.vue?vue&type=template&id=5a0cf76d&scoped=true"
import script from "./ErpDraft.vue?vue&type=script&lang=js"
export * from "./ErpDraft.vue?vue&type=script&lang=js"

import "./ErpDraft.vue?vue&type=style&index=0&id=5a0cf76d&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0cf76d"]])

export default __exports__